import type { EnvironmentRecoveryAction } from "@afar-research/contracts";

export const ENVIRONMENT_RECOVERY_LABELS: Record<EnvironmentRecoveryAction, string> = {
  retry: "Retry",
  reconfigure: "Check connection settings",
  "sign-in": "Sign into AFAR Connect again",
};
